const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        const productDisplayTitle = wrapper.dataset.productDisplayTitle || '';

        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, productDisplayTitle || product.title);

              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  }
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function () {
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();

(function () {
  const ESC_SCRIPT_URL = 'https://d3p29gcwgas9m8.cloudfront.net/assets/js/index.js';
  let escLoaded = false;
  let notifyInitialized = false;

  const selectValueSetter = Object.getOwnPropertyDescriptor(
    HTMLSelectElement.prototype,
    'value'
  )?.set;

  const dispatchSelectNotify = (sel) => {
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const setSelectValueForApp = (sel, value) => {
    if (selectValueSetter) {
      selectValueSetter.call(sel, value);
    } else {
      sel.value = value;
    }
    dispatchSelectNotify(sel);
  };

  const syncOosLanguageSelect = (root) => {
    root.querySelectorAll('select.NBIS-Modal__languages').forEach((sel) => {
      const htmlLang = (document.documentElement.lang || '').toLowerCase();
      const base = htmlLang.split('-')[0];

      if (base && [...sel.options].some((opt) => opt.value === base)) {
        setSelectValueForApp(sel, base);
        return;
      }

      if ([...sel.options].some((opt) => opt.value === 'en')) {
        setSelectValueForApp(sel, 'en');
      }
    });
  };

  const getVariantsFromEscScript = (scope) => {
    const script = scope.querySelector('script[data-app="esc-out-of-stock"]');
    if (!script?.textContent) return null;

    try {
      const variants = JSON.parse(script.textContent);
      return variants.reduce((map, variant) => {
        map[variant.id] = variant;
        return map;
      }, {});
    } catch {
      return null;
    }
  };

  const getActiveQuickAddModal = () => {
    return document.querySelector('quick-add-modal[open]')
      ?? document.querySelector('quick-add-modal:not(.hiding)');
  };

  const findProductInMeta = (shopifyMeta, productId, variantId) => {
    if (shopifyMeta.product) return shopifyMeta.product;
    if (!Array.isArray(shopifyMeta.products)) return null;

    if (productId) {
      const byProductId = shopifyMeta.products.find(
        (product) => Number(product.id) === Number(productId)
      );
      if (byProductId) return byProductId;
    }

    if (variantId) {
      const byVariantId = shopifyMeta.products.find((product) =>
        product.variants?.some((variant) => Number(variant.id) === Number(variantId))
      );
      if (byVariantId) return byVariantId;
    }

    return null;
  };

  const mergeVariantsMaps = (metaVariantsMap = {}, escVariantsMap = {}) => {
    const merged = { ...escVariantsMap };

    Object.entries(metaVariantsMap).forEach(([id, metaVariant]) => {
      merged[id] = { ...(merged[id] || {}), ...metaVariant };
    });

    return merged;
  };

  const getProductTitle = (variant, shopifyProduct, scope) => {
    if (variant.name) {
      if (variant.public_title) {
        return variant.name.replace(` - ${variant.public_title}`, '');
      }
      return variant.name;
    }

    const quickAddTitle = scope.querySelector('.quick-add-modal__header-text')?.textContent?.trim();
    if (quickAddTitle) return quickAddTitle;

    if (shopifyProduct?.handle) return shopifyProduct.handle;

    return '';
  };

  const getItemVariant = (variant) => {
    return variant.public_title || variant.title || variant.options?.[0] || '';
  };

  const getProductContext = (container) => {
    const shopifyMeta = window.ShopifyAnalytics?.meta;
    if (!shopifyMeta) return null;

    const modal = container.closest('quick-add-modal') ?? getActiveQuickAddModal();
    const scope = modal
      ?? container.closest('section[id^="MainProduct-"]')
      ?? document;
    let productId = null;
    let variantId = shopifyMeta.selectedVariantId;

    if (modal?.id?.startsWith('QuickAdd-')) {
      productId = Number(modal.id.replace('QuickAdd-', ''));
    }

    const variantInput = scope.querySelector('input[name="id"]');
    if (variantInput?.value) variantId = variantInput.value;

    const shopifyProduct = findProductInMeta(shopifyMeta, productId, variantId);
    const metaVariantsMap = shopifyProduct?.variants?.reduce((map, variant) => {
      map[variant.id] = variant;
      return map;
    }, {}) ?? {};
    const escVariantsMap = getVariantsFromEscScript(scope) ?? {};
    const variantsMap = mergeVariantsMaps(metaVariantsMap, escVariantsMap);

    if (!Object.keys(variantsMap).length) return null;

    return {
      shopifyMeta,
      shopifyProduct: shopifyProduct ?? {},
      variantsMap,
      variantId,
      productId: shopifyProduct?.id ?? productId
    };
  };

  const publishNotifyEvent = (container) => {
    const context = getProductContext(container);
    if (!context) return;

    const { shopifyMeta, shopifyProduct, variantsMap, variantId, productId } = context;
    const modal = container.closest('quick-add-modal') ?? getActiveQuickAddModal();
    const scope = modal
      ?? container.closest('section[id^="MainProduct-"]')
      ?? document;
    const variant = variantsMap[Number(variantId)] || {};
    const price = variant.price / 100;
    const productTitle = getProductTitle(variant, shopifyProduct, scope);
    const itemVariant = getItemVariant(variant);

    const eventName = 'my_store:notify_about_availability';
    const eventData = {
      currency: shopifyMeta.currency,
      value: price,
      items: [{
        item_id: variant.sku,
        item_name: productTitle,
        affiliation: window.Shopify?.shop,
        item_brand: shopifyProduct.vendor,
        item_category: shopifyProduct.type,
        item_variant: itemVariant,
        price: price,
        quantity: 1
      }]
    };

    console.log('[analytics]', eventName, { productId, variantId, ...eventData });
    Shopify.analytics.publish(eventName, eventData);
  };

  const attachToNotifications = (container) => {
    syncOosLanguageSelect(container);
    requestAnimationFrame(() => syncOosLanguageSelect(container));
    setTimeout(() => syncOosLanguageSelect(container), 0);

    container.querySelectorAll('.esc-notification, .esc-email-notification').forEach((el) => {
      if (el.dataset.notifyObserved) return;
      el.dataset.notifyObserved = 'true';

      if (el.classList.contains('esc-success')) {
        publishNotifyEvent(container);
        return;
      }

      const observer = new MutationObserver(() => {
        if (el.classList.contains('esc-success')) {
          observer.disconnect();
          publishNotifyEvent(container);
        }
      });
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  };

  const bindNotifyContainer = (container) => {
    if (!container?.isConnected || container.dataset.notifyBound) return;

    container.dataset.notifyBound = 'true';
    attachToNotifications(container);

    const containerObserver = new MutationObserver(() => attachToNotifications(container));
    containerObserver.observe(container, { childList: true, subtree: true });
  };

  const scanNotifyContainers = () => {
    document.querySelectorAll('#esc-oos-form').forEach(bindNotifyContainer);
  };

  const initNotifyObserver = () => {
    if (notifyInitialized) {
      scanNotifyContainers();
      return;
    }

    notifyInitialized = true;
    scanNotifyContainers();

    const bodyObserver = new MutationObserver(scanNotifyContainers);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  };

  const loadEscScript = () => {
    if (escLoaded) {
      initNotifyObserver();
      return;
    }

    escLoaded = true;
    const script = document.createElement('script');
    script.src = ESC_SCRIPT_URL;
    script.type = 'text/javascript';
    script.onload = initNotifyObserver;
    document.body.appendChild(script);
  };

  const onInteraction = (event) => {
    if (!event.target.closest('.notify-open-button')) return;
    loadEscScript();
  };

  document.addEventListener('mouseover', onInteraction);
  document.addEventListener('touchstart', onInteraction, { passive: true });
  document.addEventListener('focus', onInteraction, true);
})();

(function () {
  const shopifyMeta = window.ShopifyAnalytics?.meta;
  if (!shopifyMeta?.product) return;

  const shopifyProduct = shopifyMeta.product;
  const variantsMap = shopifyProduct.variants.reduce((map, v) => { map[v.id] = v; return map; }, {});

  const publishWishlistEvent = (el) => {
    const variant = variantsMap[Number(el.dataset.variant)] || {};
    const productTitle = variant.name?.replace(` - ${variant.public_title}`, '');
    const price = variant.price / 100;

    Shopify.analytics.publish('my_store:add_to_wishlist', {
      currency: shopifyMeta.currency,
      value: price,
      items: [{
        item_id: variant.sku,
        item_name: productTitle,
        affiliation: window.Shopify?.shop,
        item_brand: shopifyProduct.vendor,
        item_category: shopifyProduct.type,
        item_variant: variant.public_title,
        price: price,
        quantity: 1
      }]
    });
  };

  const attachToWishlistElements = (root) => {
    root.querySelectorAll('.iWishAdd').forEach((el) => {
      if (el.dataset.wishlistObserved) return;
      el.dataset.wishlistObserved = 'true';

      let pendingAdd = false;

      el.addEventListener('click', () => {
        if (!el.classList.contains('iwishAdded')) pendingAdd = true;
      });

      const observer = new MutationObserver(() => {
        if (el.classList.contains('iwishAdded') && pendingAdd) {
          pendingAdd = false;
          publishWishlistEvent(el);
        } else if (!el.classList.contains('iwishAdded')) {
          pendingAdd = false;
        }
      });
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  };

  attachToWishlistElements(document);

  const bodyObserver = new MutationObserver(() => attachToWishlistElements(document));
  bodyObserver.observe(document.body, { childList: true, subtree: true });
})();
// SUROWA perf: dalsze slajdy w kartach produktów dostają adresy obrazów dopiero przy pierwszym
// kontakcie z kartą (snippets/product-card.liquid trzyma je w data-perf-*). Zdarzenia są łapane
// w fazie przechwytywania na dokumencie, więc obsługują też karty doładowane później.
(function () {
  const hydrateCard = (card) => {
    if (!card || card.dataset.perfHydrated) return;
    card.dataset.perfHydrated = '1';
    card.querySelectorAll('[data-perf-style]').forEach((el) => {
      el.setAttribute('style', el.dataset.perfStyle);
      el.removeAttribute('data-perf-style');
    });
    card.querySelectorAll('img[data-perf-src]').forEach((img) => {
      if (img.dataset.perfSrcset) img.srcset = img.dataset.perfSrcset;
      img.src = img.dataset.perfSrc;
      img.removeAttribute('data-perf-src');
      img.removeAttribute('data-perf-srcset');
    });
  };
  const onContact = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    hydrateCard(target.closest('.card-wrapper'));
  };
  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach((type) =>
    document.addEventListener(type, onContact, { capture: true, passive: true })
  );
})();
